<div class="flex flex-row lt-lg:flex-col gap-[24px] xs:gap-[16px] justify-start items-start">
  <app-feature-list-container
    class="full-width flex-[65%] max-w-[65%] lt-lg:flex-[100%] lt-lg:max-w-[100%]"
  >
    <div
      class="flex flex-row lt-md:flex-col gap-[24px] xs:gap-[16px] justify-center items-center lt-md:justify-start lt-md:items-start"
    >
      <div class="img-wrapper">
        <img src="assets/img/gateway-light.png" />
      </div>
      <div class="full-width flex flex-col gap-[18px] justify-start items-start">
        <div class="commissioning-subtitle">
          {{ '+GATEWAY_COMMISSIONING_REDESIGN.IS_LIGHT_UP' | translate }}
        </div>
        <mat-radio-group class="flex flex-col gap-[18px] justify-start items-start">
          <mat-radio-button
            gtm="onSet"
            gtmAction="The light is not visible"
            gtmCategory="gatewayCommissioningCheckLight"
            checked
            data-at-commissioning-check-light="false"
            [value]="false"
            (change)="lightIsNotVisible = false"
            >{{ '+GATEWAY_COMMISSIONING_REDESIGN.LAMP_IS_UP' | translate }}</mat-radio-button
          >
          <mat-radio-button
            gtm="onSet"
            gtmAction="The light is visible"
            gtmCategory="gatewayCommissioningCheckLight"
            data-at-commissioning-check-light="true"
            [value]="true"
            (change)="lightIsNotVisible = true"
            >{{ '+GATEWAY_COMMISSIONING_REDESIGN.LAMP_IS_NOT_UP' | translate }}</mat-radio-button
          >
        </mat-radio-group>
        <div
          *ngIf="lightIsNotVisible"
          class="actions-wrapper flex flex-col gap-[18px] justify-start items-start"
        >
          <span class="commissioning-subtitle">{{
            '+GATEWAY_COMMISSIONING_REDESIGN.TRY_AGAIN' | translate
          }}</span>
          <span class="commissioning-description">{{
            '+GATEWAY_COMMISSIONING_REDESIGN.TRY_AGAIN_DESCRIPTION' | translate
          }}</span>
          <span class="actions-list">
            <app-order-container [order]="1">
              <div>{{ '+GATEWAY_COMMISSIONING_REDESIGN.TRY_AGAIN_OPTION1' | translate }}</div>
            </app-order-container>
            <app-order-container [order]="2">
              <div>{{ '+GATEWAY_COMMISSIONING_REDESIGN.TRY_AGAIN_OPTION2' | translate }}</div>
            </app-order-container>
          </span>

          <button
            class="back-btn"
            data-at-back-button
            mat-raised-button
            color="primary"
            gtm="onPreviousStep"
            gtmAction="Go back to commissioning"
            gtmCategory="gatewayCommissioningCheckLight"
            (click)="previousStepClicked(step.INSTRUCTIONS)"
          >
            {{ '+GATEWAY_COMMISSIONING_REDESIGN.GO_BACK_TO_COMMISSIONING' | translate }}
          </button>
        </div>
      </div>
    </div>
  </app-feature-list-container>

  <div class="steps-wrapper flex flex-col gap-[24px] xs:gap-[16px] flex-1">
    <div class="flex flex-col gap-[24px] xs:gap-[16px]">
      <div class="flex flex-col md:flex-row gap-[24px] xs:gap-[16px]">
        <app-edit-commissioning-step
          class="flex-1"
          [title]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_SELECTION.TITLE'"
          [description]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_SELECTION.COMPLETED'"
          [showEditButton]="true"
          [displayConfirmDialog]="true"
          (previousStep)="previousStepClicked(step.SELECT_INSTALLATION_TYPE)"
        ></app-edit-commissioning-step>
        <app-edit-commissioning-step
          class="flex-1"
          [title]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_CONNECTION.TITLE'"
          [description]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_CONNECTION.COMPLETED'"
          [showEditButton]="true"
          (previousStep)="previousStepClicked(step.INSTRUCTIONS)"
        ></app-edit-commissioning-step>
      </div>
      <app-edit-commissioning-step
        class="flex-1"
        [title]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_TRANSFER_INSTALLATION.TITLE'"
        [description]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP.CONTINUE_LAST_STEP'"
      ></app-edit-commissioning-step>
    </div>
    <button
      class="next-step-btn flex-1"
      gtm="onNextStep"
      gtmAction="Go to tranfer data step"
      gtmCategory="gatewayCommissioningGwNetwork"
      mat-raised-button
      data-at-next-button
      color="primary"
      [disabled]="lightIsNotVisible"
      (click)="nextStepClicked()"
    >
      <span>{{ 'GENERAL.BUTTON.NEXT_STEP' | translate }}</span>
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</div>
